<template>
  <div class="cont-main">
    <div class="top-form">
      <e-form
        ref="refForm1"
        :config="formConfig"
        :column="formColumn1"
        :data.sync="detailData.formData"
        disabled
      />
      <e-form
        ref="refForm4"
        class="form4"
        :config="formConfig"
        :column="formColumn4"
        :data.sync="detailData.gong_cheng_xie_tong_formData"
        :disabled="isDisabledPage"
      />
    </div>

    <div class="table-main" :style="{ 'max-height': maxHeight }">
      <el-link
        v-if="xietongId"
        class="link-total-detail"
        type="warning"
        @click="openPopupVerifyGoodsDetail"
      >
        制造明细
      </el-link>
      <TableSale
        tableTitle="bom表清单"
        :parent="null"
        :data.sync="detailData.tableSaleData"
        :disabled="isDisabledPage"
        :statusName="detailData.gong_cheng_xie_tong_formData.xie_tong_status_str"
      />
    </div>
    <div class="flex flex-y-center flex-x-between m-t-10">
      <div class="m-t-10">
        <e-form
          :config="formConfig"
          :column="formColumn2"
          :data.sync="detailData.formData"
          :disabled="isDisabledPage"
        />
      </div>
      <div class="total-main">
        <span v-for="(item, index) in formColumn3" :key="index" class="total-item">
          <span>{{ item.title }}:</span>
          <span class="total-item-price">{{ detailData.formData[item.field] }}</span>
          <span>{{ item.suffix }}</span>
        </span>
      </div>
    </div>
    <div v-if="!isDisabledPage" class="flex flex-y-center flex-x-end b-t-1 p-t-10">
      <el-button v-if="detailData.isFuZe" type="primary" size="mini" @click="itemSave">
        保存
      </el-button>
      <el-button
        v-if="detailData.xie_tong_status_str === '处理中' && detailData.isFuZe"
        type="success"
        size="mini"
        @click="itemFinish"
      >
        确认完成
      </el-button>
    </div>

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="detailData.formData.id"
    />
  </div>
</template>

<script>
import math from './math'
import TableSale from './table-sale'
export default {
  components: {
    TableSale
  },
  props: {
    xietongId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isItemFinish: false,
      formConfig: {
        width: '200px'
      },
      formColumn1: [
        {
          type: 'date',
          title: '销售日期',
          field: 'bill_date',
          required: true,
          disabled: true,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          placeholder: '自动生成',
          required: true,
          disabled: true
        },
        {
          type: 'select',
          title: '业务员',
          field: 'saler_name',
          options: [],
          disabled: true,
          width: '240px'
        },
        {
          type: 'text',
          title: '客户',
          field: 'company_merge_str',
          disabled: true,
          width: '308px'
        },
        {
          type: 'text',
          title: '开单公司',
          field: 'saler_company_name',
          disabled: true,
          width: '308px'
        },
        {
          type: 'text',
          title: '单据备注',
          field: 'bill_remark',
          disabled: true,
          width: '400px'
        }
      ],
      formColumn4: [
        {
          type: 'text',
          title: '协同工程师',
          field: 'xie_tong_user_name',
          disabled: true,
          width: '240px'
        },
        {
          type: 'number',
          title: '预计工时',
          field: 'yu_ji_gong_shi',
          suffix: '小时',
          disabled: false,
          width: '308px'
        },
        {
          type: 'datetime',
          title: '预计完工',
          field: 'yu_ji_wan_gong',
          disabled: false,
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          width: '308px'
        }
      ],
      formColumn2: [
        {
          type: 'number',
          title: '税率',
          field: 'bill_tax_rate',
          suffix: '%',
          fnChange: () => {
            math.totalFormData(this.detailData) // 计算-表格汇总计算
          }
        },
        {
          type: 'number',
          title: '税金',
          field: 'tax_fees_total',
          suffix: '元',
          placeholder: '自动计算',
          disabled: true
        }
      ],
      formColumn3: [
        {
          title: '订单成本',
          field: 'cost_price_total',
          suffix: '元',
        },
        {
          title: '订单销售金额',
          field: 'sales_amount_total',
          suffix: '元',
        },
        {
          title: '订单利润',
          field: 'profit_total',
          suffix: '元',
        },
        {
          title: '订单利润率',
          field: 'profit_rate_total',
          suffix: '%',
        },
        {
          title: '提成金额',
          field: 'push_money',
          suffix: '元',
        }
      ],

      detailData: {
        formData: {
          version: 2,
          bill_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 销售日期
          bill_code: '', // 销售单号
          saler_id: '', // 业务员id
          saler_name: '', // 业务员
          commission_rate: '', // 提成比例
          company_name: '', // 客户
          company_id: '', // 客户id
          company_uuid: '', // 客户uuid
          company_merge_str: '', // 客户合并字段
          saler_company_name: '', // 开单公司
          bill_remark: '', // 单据备注
          xie_tong_user_name: '', // 协同工程师
          bill_tax_rate: '', // 税率
          tax_fees_total: '', // 税金
          cost_price_total: '', // 订单成本
          sales_amount_total: '', // 订单销售金额
          profit_total: '', // 订单利润
          profit_rate_total: '', // 订单利润率
          push_money: '', // 提成金额
          status_str: '暂存'
        },
        gong_cheng_xie_tong_formData: {},
        tableSaleData: []
      }, // 详情数据
      detailTimer: null, // 详情数据更新计时器

      isShowPopupVerifyGoodsDetail: false, // 制造明细
      activeId: null
    }
  },
  computed: {
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 420}px`
      return result
    },
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    accountId() {
      return this.$store.state.loginAccount.id
    },
    isDisabledPage() {
      let result =
        !this.detailData.isFuZe ||
        this.detailData.gong_cheng_xie_tong_formData.xie_tong_status_str === '已取消' ||
        this.detailData.gong_cheng_xie_tong_formData.xie_tong_status_str === '已完成'
      return result
    },
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  watch: {
    'detailData.tableSaleData': {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            if (this.detailTimer) {
              clearTimeout(this.detailTimer)
            }
            this.detailTimer = setTimeout(() => {
              math.totalDetailData(this.detailData) // 计算-汇总详情
              this.detailTimer = null
            }, 100)
          }
        })
      },
      deep: true
    },
    'detailData.gong_cheng_xie_tong_formData.yu_ji_gong_shi': {
      handler(val) {
        if (val) {
          let nowSeconds = new Date().getTime()
          let hourSeconds = 3600 * 1000
          let addSeconds = this.$XEUtils.multiply(val, hourSeconds)
          let result = this.$util.formatDate(new Date(nowSeconds + addSeconds), true)
          result = result.slice(0, -2) + '00'
          this.detailData.gong_cheng_xie_tong_formData.yu_ji_wan_gong = result
        }
      }
    }
  },
  mounted() {
    if (this.xietongId) {
      this.getDetailData()
    } else {
      this.detailData.formData.commission_rate = this.selfAccountData.commission_rate // 初始化-提成比例
      this.detailData.tableSaleData = [this.$util.deepCopy(this.$constant.newTableSaleObj)] // 初始化-数据结构
    }
  },
  methods: {
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/gongChengXieTong/detail',
        params: {
          id: this.xietongId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          result.isChuangJian =
            this.isAdmin || result.gong_cheng_xie_tong_formData.create_name_id === this.accountId
          result.isFuZe =
            this.isAdmin || result.gong_cheng_xie_tong_formData.xie_tong_user_id === this.accountId

          let { company_name, company_id } = result.formData
          result.formData.company_merge_str = result.isChuangJian ? company_name : company_id

          this.detailData = result
        }
      })
    },
    // 项-保存
    itemSave() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongChengXieTong/heSuanDansaveOrUpdate',
        data: this.detailData
      }).then((res) => {
        if (res.data.state === 'ok') {
          if (this.isItemFinish) {
            this.isItemFinish = false
            this.itemFinishConfirm()
            return
          } else {
            this.itemChuLiConfirm()
          }
          this.$message.success('操作成功')
        }
      })
    },
    // 项-完成
    itemFinish() {
      this.$confirm(
        `您确定要完成“${this.detailData.gong_cheng_xie_tong_formData.xie_tong_bill_code}”的工程协同任务吗?`,
        '完成确认'
      )
        .then(() => {
          if (this.isDisabledPage) {
            this.itemFinishConfirm()
          } else {
            this.isItemFinish = true
            this.itemSave()
          }
        })
        .catch(() => {})
    },
    // 项-完成-确认
    itemFinishConfirm() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/gongChengXieTong/doWanCheng',
        params: {
          id: this.xietongId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.popupCancel()
        }
      })
    },
    // 项-处理-确认
    itemChuLiConfirm() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/gongChengXieTong/doChuLiZhong',
        params: {
          id: this.xietongId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.popupCancel()
        }
      })
    },
    // 制造明细
    openPopupVerifyGoodsDetail() {
      this.isShowPopupVerifyGoodsDetail = true
    },
    // 弹窗取消
    popupCancel() {
      this.$emit('success')
    }
  }
}
</script>

<style lang="less" scoped>
.cont-main {
  .table-main {
    position: relative;
    border: 1px solid #e8eaec;
    min-height: 390px;
    overflow-y: auto;
    overflow-x: hidden;
    .scroll-bar();
    .link-total-detail {
      position: absolute;
      top: 8px;
      left: 85px;
      font-size: 14px;
      font-weight: bold;
      z-index: 99;
    }
  }
  .total-main {
    height: 48px;
    line-height: 48px;
    .total-item {
      & ~ .total-item {
        margin-left: 10px;
      }
      .total-item-price {
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: @colorRed;
      }
    }
  }
  .top-form {
    position: relative;
    .form4 {
      position: absolute;
      bottom: 0;
      left: 400px;
    }
  }
}
</style>
